import ipaddr from "ipaddr.js";
import {hasValue} from "@/utils/ValueUtils";

export function isValidIpAddress(value: string | null | undefined): boolean {
    return hasValue(value) && (ipaddr.isValid(value) || ipaddr.isValidCIDR(value));
}
